export const paths = {
  home: "/",
  whyBasilium: "/why-basilium",
  termsAndConditions: "/terms-and-conditions",
  privacyPolicy: "/privacy-policy",
  faq: "/frequently-asked-questions",
};
